import { render, staticRenderFns } from "./TOCTemp4.vue?vue&type=template&id=04638846&scoped=true&"
import script from "./TOCTemp4.vue?vue&type=script&lang=js&"
export * from "./TOCTemp4.vue?vue&type=script&lang=js&"
import style0 from "./TOCTemp4.vue?vue&type=style&index=0&id=04638846&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04638846",
  null
  
)

export default component.exports